import {Component, OnInit, AfterViewInit} from '@angular/core';
import {BaseComponent} from '../../../base/base.component';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {
    DaycarePickupPage,
    GetUnitiesGQL,
    SearchDaycarePickupGQL,
    SearchDaycarePickupInput,
    SearchDaycarePickupQuery,
    Unity,
    User
} from '../../../../generated/graphql';
import {QueryRef} from 'apollo-angular';
import {UserService} from '../../../service/user.service';
import {FilterService} from '../../../service/filter.service';
import {DaycareService} from '../../../service/daycare.service';

/**
 * Fatia 7 — HISTÓRICO de retiradas (§47.3.4). Lê os SNAPSHOTS de
 * daycare_pickup_record (não o cadastro atual). Listagem paginada (padrão 5B) +
 * filtros (keyword + período) persistidos via FilterService + export Excel.
 * Perfis (§47.2): admin, local-manager, vigilant, vigilant-leader.
 */
@Component({
    selector: 'app-daycare-history',
    templateUrl: './daycare-history.component.html',
    styleUrls: ['./daycare-history.component.scss']
})
export class DaycareHistoryComponent extends BaseComponent implements OnInit, AfterViewInit {

    filterKey = 'daycare_history_filter';
    user = new User();
    searchQuery: QueryRef<SearchDaycarePickupQuery>;
    page: DaycarePickupPage = new DaycarePickupPage();
    // startDate/endDate ficam como 'YYYY-MM-DD' nos inputs; convertidos p/ ISO no buildFilter.
    // status: '' (todos) | 'in' (dentro agora) | 'out' (já saíram) — Fatia 8B.
    filter: { keyword?: string, startDate?: string, endDate?: string, unityId?: string, status?: string, page?: number } = {page: 1};

    showUnitySelector = false; // só admin
    unities: Array<Unity> = [];
    loading = false;

    constructor(public router: Router,
                public translate: TranslateService,
                public userService: UserService,
                private filterService: FilterService,
                private daycareService: DaycareService,
                private searchGQL: SearchDaycarePickupGQL,
                private getUnitiesGQL: GetUnitiesGQL
    ) {
        super(router, translate);
    }

    ngOnInit() {
        const saved = this.filterService.getFilter(this.filterKey) as any;
        if (saved) {
            this.filter = {
                keyword: saved.keyword || '',
                startDate: saved.startDate || '',
                endDate: saved.endDate || '',
                unityId: saved.unityId || null,
                status: saved.status || '',
                page: 1
            };
        }
    }

    ngAfterViewInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
                this.actionUserProfileBTN();
                if (this.actionUserProfile() === false) {
                    super.showMessage(this.translate.instant('atencao'), this.translate.instant('semacesso'), 'warning');
                    this.router.navigate(['/']);
                    return;
                }
                if (this.showUnitySelector) {
                    this.loadUnities();
                }
                this.actionList();
            }, error: err => super.onError(err)
        });
    }

    loadUnities() {
        this.getUnitiesGQL.watch().valueChanges.subscribe(({data}) => {
            this.unities = (data.unities || []) as Array<Unity>;
        }, error => super.onError(error));
    }

    buildFilter(): SearchDaycarePickupInput {
        return {
            keyword: this.filter.keyword || '',
            startDate: this.filter.startDate ? new Date(this.filter.startDate + 'T00:00:00').toISOString() : null,
            endDate: this.filter.endDate ? new Date(this.filter.endDate + 'T23:59:59').toISOString() : null,
            unityId: this.showUnitySelector ? (this.filter.unityId || null) : null,
            status: this.filter.status || null,
            page: this.filter.page || 1
        };
    }

    actionList() {
        this.filter.page = 1;
        this.loading = true;
        this.searchQuery = this.searchGQL.watch({data: this.buildFilter()});
        this.searchQuery.valueChanges.subscribe(({data}) => {
            this.page = data.searchDaycarePickup as DaycarePickupPage;
            this.loading = false;
        }, error => {
            this.loading = false;
            super.onError(error);
        });
    }

    actionFilter() {
        this.loading = true;
        this.searchQuery.refetch({data: this.buildFilter()}).then(() => this.loading = false);
        this.filterService.setFilter(this.filterKey, this.filter);
    }

    actionSearch() {
        this.filter.page = 1;
        this.actionFilter();
    }

    pageChanged(event) {
        this.filter.page = event;
        this.actionFilter();
    }

    clearFilter() {
        this.filterService.clearFilter(this.filterKey);
        this.filter = {keyword: '', startDate: '', endDate: '', unityId: null, status: '', page: 1};
        this.actionFilter();
    }

    actionExcel() {
        this.loading = true;
        const f = this.buildFilter();
        this.daycareService.exportPickupExcel({
            unityId: f.unityId || undefined,
            keyword: f.keyword || undefined,
            startDate: f.startDate || undefined,
            endDate: f.endDate || undefined,
            status: f.status || undefined
        }).subscribe({
            next: (data: any) => {
                this.loading = false;
                super.downloadHandlerFile(data);
            }, error: err => {
                this.loading = false;
                super.onError(err);
            }
        });
    }

    isEmployee(kind: string): boolean {
        return kind === 'employee';
    }

    isParent(kind: string): boolean {
        return kind === 'parent';
    }

    actionUserProfile(): boolean {
        switch (this.user.profile) {
            case 'admin':
            case 'local-manager':
            case 'vigilant':
            case 'vigilant-leader':
                return true;
            default:
                return false;
        }
    }

    actionUserProfileBTN() {
        this.showUnitySelector = this.user.profile === 'admin';
    }
}
